import { render, staticRenderFns } from "./html-image.vue?vue&type=template&id=1260ab0c"
import script from "./html-image.vue?vue&type=script&lang=ts"
export * from "./html-image.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports